import Vue from 'vue'
import router from '@/router'
import store from '@/store'
import vuetify from '@/plugins/vuetify'
import axios from '@/plugins/axios'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  axios,
  created() {
    this.$store.dispatch('init')
    if (window.location.pathname === '/') {
      this.$router.replace(localStorage.getItem('lastRoute'))
    }
  },
  render: h => h('router-view')
}).$mount('#app')
